import _ from 'lodash';
import React, { Component } from 'react';
import { parseTextStyling } from '../../../utils/shared';
import { DEFAULT_CYCLE, LOREM_IPSUM } from './AlbuquerqueConstants';

class AlbuquerqueStoryTextOnly extends Component {
  constructor(props) {
    super(props);
    this._cycleTimeoutHandler = null;
  }
  
  componentDidMount() {
    this.setupCycle();
  }

  componentWillUnmount() {
    clearTimeout(this._cycleTimeoutHandler);
  }

  setupCycle = () => {
    const time = _.get(this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
    this._cycleTimeoutHandler = setTimeout(() => {
      this.props.cycle();
    }, time * 1000)
  }

  render() {
    const headline = _.get(this.props.module, 'contents.custom_fields.headline.val', "Headline");
    const body = _.get(this.props.module, 'contents.custom_fields.body.val', LOREM_IPSUM);
    const headlineRawStyle = _.get(this.props.module, 'contents.custom_fields.headline_style', null);
    const bodyRawStyle = _.get(this.props.module, 'contents.custom_fields.body_style', null);

    const headlineStyle = parseTextStyling(headlineRawStyle);
    const bodyStyle = parseTextStyling(bodyRawStyle);

    return (
      <div>
        {/* <div style={{ position: "absolute", width: "100%", height: "100%", opacity: OPACITY_PERCENTAGE, backgroundColor: OPACITY_COLOR }}/> */}
        <div style={{ position: "absolute", width: "100%", height: "100%", display: "table" }}>
          <div style={{ width: "45%", display: "table-cell", verticalAlign: "middle", paddingLeft: "25%", paddingRight: "25%" }}>
            <div style={{ ...headlineStyle, fontFamily: "legacysans-bold" }}>{headline}</div>
            <br/>
            <div style={{ ...bodyStyle, fontFamily: "legacysans-book" }}>{body}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlbuquerqueStoryTextOnly;


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueStoryTextOnly.jsx